import { useState } from 'react';
import { axios } from 'services/axios';
import { API_RESULT_FIELDS_TO_EXPORT, FAILED_FILENAME } from './constants';
import Papa from 'papaparse';
import { downloadCSV } from 'utils/utils';

export default function useCSVNumberBlocksBulkUpdate() {
    const [loading, setLoading] = useState(false);
    const [counter, setCounter] = useState(0);
    const [errorCounter, setErrorCounter] = useState(0);
    const [total, setTotal] = useState(0);
    const [error, setError] = useState([]);
    const [succeed, setSucceed] = useState([]);

    const handlePayloadChange = async (payloads) => {
        try {
            setLoading(true);
            setTotal(payloads.length);
            setCounter(0);
            setErrorCounter(0);
            setError([]);
            setSucceed([]);

            for (const payload of payloads) {
                try {
                    // Check if delete flag is set
                    if (payload.delete) {
                        // Call DELETE /api/ui/NumberBlock/{id}
                        await axios.delete(`/NumberBlock/${payload.id}`);
                    } else {
                        // Call PUT /api/ui/NumberBlock
                        await axios.put('/NumberBlock', {
                            id: payload.id,
                            partnerID: payload.partnerID,
                            companyID: payload.companyID,
                            // inboundCarrierID: payload.inboundCarrierID,
                            // outboundCarrierID: payload.outboundCarrierID,
                            publicPool: payload.publicPool,
                        });
                    }

                    setSucceed((prev) => [
                        ...prev,
                        {
                            ...payload,
                            // Explicitly preserve id and companyID for table display (delete API doesn't return these)
                            id: payload.id,
                            companyID: payload.companyID,
                            result: payload.delete ? 'Deleted' : 'Success',
                        },
                    ]);
                } catch (e) {
                    console.error('Error updating number block:', e);
                    const errorMessage =
                        e.response?.data?.message ||
                        e.response?.data?.title ||
                        e.message ||
                        'Unknown error';

                    setError((prev) => [
                        ...prev,
                        {
                            id: payload.id,
                            companyID: payload.companyID,
                            apiErrors: errorMessage,
                        },
                    ]);
                    setErrorCounter((prev) => prev + 1);
                } finally {
                    // Always increment counter regardless of success or error
                    setCounter((prev) => prev + 1);
                }
            }

            setLoading(false);
        } catch (e) {
            console.error('Bulk update error:', e);
            setLoading(false);
        }
    };

    const handleExportFailedData = () => {
        const exportFailedData = error.map((block) => {
            return Object.keys(API_RESULT_FIELDS_TO_EXPORT).reduce(
                (acc, key) => {
                    const value = block[key];
                    const newKey = API_RESULT_FIELDS_TO_EXPORT[key];
                    acc[newKey] = value;
                    return acc;
                },
                {},
            );
        });
        const res = Papa.unparse(exportFailedData);
        downloadCSV(res, FAILED_FILENAME);
    };

    return {
        handlePayloadChange,
        loading,
        counter,
        errorCounter,
        error,
        succeed,
        handleExportFailedData,
        total,
    };
}
